import React, {Component} from 'react';
import {getLangCode, stringBundle} from '../../stringBundle';

class AdditionalPrefs extends Component {

  constructor(props) {
    super(props);
    this.localizedStringBundle = stringBundle(getLangCode());
  }

  render() {
    return (
      <div className="contact-form padding-left-10-s">
        <div className="section-title additional-prefs">{this.localizedStringBundle.MANAGE_AP_ADDITIONAL_TITLE}</div>
        <div className="row">
          <div className="col s12 m12 l12 no-padding-left">
            {this.localizedStringBundle.MANAGE_AP_ADDPREF_CLICK} <a target="_blank" rel="noopener noreferrer">{this.localizedStringBundle.MANAGE_AP_ADDPREF_HERE}</a> {this.localizedStringBundle.MANAGE_AP_ADDPREF_TO_MANAGE}
          </div>
        </div>
      </div>
    )
  }

}

export default AdditionalPrefs;



// WEBPACK FOOTER //
// ./src/containers/monitoring/AdditionalPrefs.js